import { Widget } from './Componets/Widget';
import { useTranslation } from 'react-i18next';
import { SubscriptionStatusChart } from './Charts/SubscriptionStatusChart';
import { ActiveInSessionChart } from './Charts/ActiveInSessionChart';
import { RSimStatusChart } from './Charts/RSimStatusChart';
import { useDashboardAccountRef } from './hooks/useDashboardAccountRef';
import {
  GridLayout,
  GridLayoutFullWidthItem,
  GridLayoutHighItem,
  GridLayoutItem,
  GridLayoutWideItem,
} from 'src/common/components/Layouts/GridLayout/GridLayout';
import { UsageSectionWidget } from './Componets/UsageSection';
import { AreaChartWithUserSelectAndSuspenseContainer } from 'src/common/components/Graphs/common/Graphs/AreaChartWithSelectSuspend';
import { InventoryChart } from './Charts/InventoryChart';
import { getMonths } from 'src/common/utils/chartAxisLabelsUtils';
import { AreaWidgetErrorBoundary } from './Componets/AreaWidgetErrorBoundary';
import { DoughnutChartWidget } from 'src/common/components/Graphs/common/Graphs/components/DoughnutChartWidget';

export const Dashboard = () => {
  const { t } = useTranslation();

  const accountRef = useDashboardAccountRef();

  return (
    <GridLayout>
      <GridLayoutFullWidthItem key="monthlyUsage" data-testid="monthlyUsage">
        <UsageSectionWidget accountRef={accountRef} key={accountRef} />
      </GridLayoutFullWidthItem>
      <GridLayoutHighItem key="subscriptionStatus" data-testid="subscriptionsStatus">
        <DoughnutChartWidget
          title={t('dashboard.subscriptionsStatusChart.title')}
          accountRef={accountRef}
        >
          {(accountRef) => <SubscriptionStatusChart accountRef={accountRef} />}
        </DoughnutChartWidget>
      </GridLayoutHighItem>
      <GridLayoutItem key="activeInSession" data-testid="activeInSession">
        <DoughnutChartWidget
          title={t('dashboard.activeInSessionChart.title')}
          accountRef={accountRef}
        >
          {(accountRef) => <ActiveInSessionChart accountRef={accountRef} />}
        </DoughnutChartWidget>
      </GridLayoutItem>
      <GridLayoutItem key="rsimStatus" data-testid="rSimStatus">
        <DoughnutChartWidget title={t('dashboard.rSimStatusChart.title')} accountRef={accountRef}>
          {(accountRef) => <RSimStatusChart accountRef={accountRef} />}
        </DoughnutChartWidget>
      </GridLayoutItem>
      <GridLayoutWideItem key="inventory" data-testid="inventory">
        <AreaWidgetErrorBoundary
          title={t('dashboard.inventoryChart.title')}
          key={accountRef}
          xAxisLabels={getMonths()}
        >
          <Widget title={t('dashboard.inventoryChart.title')}>
            <AreaChartWithUserSelectAndSuspenseContainer
              accountRef={accountRef}
              xAxisLabels={getMonths()}
            >
              {(accountRef) => <InventoryChart accountRef={accountRef} />}
            </AreaChartWithUserSelectAndSuspenseContainer>
          </Widget>
        </AreaWidgetErrorBoundary>
      </GridLayoutWideItem>
    </GridLayout>
  );
};
